/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { ResultContext } from "./result";

const resultFooterVariants = cva("pt-3", {
  variants: {
    size: {
      default: "",
      sm: "",
      lg: "",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const ResultFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  const { size } = React.useContext(ResultContext);

  return (
    <div className={cn(resultFooterVariants({ size }), className)} {...props} />
  );
};

export { ResultFooter, resultFooterVariants };
